import { AbstractJavascriptFunctionCallFactory } from "./AbstractJavascriptFunctionCallFactory";
import { AbstractJavascriptFunctionCallVO } from "./AbstractJavascriptFunctionCallVO";
import { JavascriptCallOnRegisterCompleteVO } from "./JavascriptCallOnRegisterCompleteVO";
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 02.10.12, 17:37
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import { EnvGlobalsHandler } from "../../../EnvGlobalsHandler";
import { BasicModel } from "../../../model/BasicModel";

export class JavascriptCallOnRegisterCompleteFactory implements AbstractJavascriptFunctionCallFactory {
    public createVO(): AbstractJavascriptFunctionCallVO {
        let vo: JavascriptCallOnRegisterCompleteVO = new JavascriptCallOnRegisterCompleteVO(EnvGlobalsHandler.globals.accountId, BasicModel.userData.playerID, BasicModel.instanceProxy.selectedInstanceVO.instanceId, EnvGlobalsHandler.globals.networkId, EnvGlobalsHandler.globals.gameId);
        return vo;
    }
}

